import { render, staticRenderFns } from "./job-benefits.vue?vue&type=template&id=34924ca2"
import script from "./job-benefits.vue?vue&type=script&lang=js"
export * from "./job-benefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports